export default __webpack_public_path__ + "static/media/step-three.3bf42138.jpg";